export const categoryDtoMap = {
  "1.1 Stationary Combustion": "1_1",
  "1.2 Mobile Combustion": "1_2",
  "1.3 Industrial Processes": "1_3",
  "1.4 Fugitive Emissions": "1_4",
  "1.5 Land Use, Land Use Change and Forestry (LULUCF)": "1_5",
  "2.1 Imported Electricity": "2_1",
  "2.2 Imported Energy": "2_2",
  "3.1 Upstream Transport and Distribution for Goods": "3_1",
  "3.2 Downstream Transport and Distribution for Goods": "3_2",
  "3.3 Employee Commuting": "3_3",
  "3.4 Client and Visitor Transport": "3_4",
  "3.5 Business Travel": "3_5",
  "4.1 Goods Purchased by an Organization": "4_1",
  "4.2 Capital Goods that are Purchased and Amortized by an Organization":
    "4_2",
  "4.3 Disposal Services (of solid or liquid waste) Used by an Organization":
    "4_3",
  "4.4 Use of Assets (through leased equipment) by an Organization": "4_4",
  "4.5 Use of Services not Described in the above sub-categories by an Organization":
    "4_5",
  "5.1 Use Stage of the Product": "5_1",
  "5.2 Downstream Leased Assets": "5_2",
  "5.3 End of Life Stage of the Product": "5_3",
  "5.4 Investments": "5_4",
  "6.1 Indirect GHG Emissions from other sources": "6_1",
  "1.1 Direct Emissions from Stationary Combustion": "1_1",
  "1.2 Direct Emissions from Mobile Combustion": "1_2",
  "1.3 Direct Emissions from Process Sources": "1_3",
  "1.4 Direct Emissions from Fugitive Sources": "1_4",
  "1.5 Direct Emissions from Agricultural Sources": "1_5",
  "2.1 Indirect Emissions from Purchased/Acquired Electricity": "2_1",
  "2.2 Indirect Emissions from Purchased/Acquired Steam": "2_2",
  "2.3 Indirect Emissions from Purchased/Acquired Heating": "2_3",
  "2.4 Indirect Emissions from Purchased/Acquired Cooling": "2_4",
  "3.4 Upstream Transportation and Distribution": "3_4",
  "3.6 Business Travel": "3_6",
  "3.7 Employee Commuting": "3_7",
  "3.9 Downstream Transportation and Distribution": "3_9",
  "3.1 Purchased Goods and Services": "3_1",
  "3.2 Capital Goods": "3_2",
  "3.3 Fuel and Energy-related Activities(not included in Scope 1 or Scope 2)": "3_3",
  "3.5 Waste Generated in Operations": "3_5",
  "3.8 Upstream Leased Assets": "3_8",
  "3.10 Processing of Solid Products": "3_10",
  "3.11 Use of Solid Products": "3_11",
  "3.12 End-of-Life Treatment of Solid Products": "3_12",
  "3.13 Downstream Leased Assets": "3_13",
  "3.14 Franchise (Scope 1 and Scope 2)": "3_14",
  "3.15 Investments": "3_15",
  "Emission Removal & Mitigation": "rm",
};
